import { i18n } from "@/setup/i18n-setup";
import { VatDeclarationPeriod } from "./period";

export class VatDeclarationMonthPeriod extends VatDeclarationPeriod {
	public ForMonth:number =  new Date().getMonth() + 1;

	public getJSON() {
		return {
			Year: this.Year,
			ForMonth: this.ForMonth
		};
	}

	public toString(): string {
		return i18n.t(`common.months.${this.ForMonth}`).toString();
	}
}